const env = typeof process !== 'undefined' ? process.env : import.meta.env

export const IS_LOWCODE_ENABLED = env.VITE_IS_LOWCODE_ENABLED === 'true'
export const IS_WORKFLOW_ENABLED = env.VITE_IS_WORKFLOW_ENABLED === 'true'
export const IS_DEMO_OPTIMIZE_ENABLED = env.VITE_IS_DEMO_OPTIMIZE_ENABLED === 'true'
export const SESSION_OVER_MS = Number(localStorage.getItem('SESSION_OVER_MS') || env.VITE_SESSION_OVER_MS)
export const IS_DANONE_ENV = env.VITE_APP_NAME === 'Danone'
export const IS_JUME_ENV = env.VITE_APP_NAME === 'JumeForecast'
export const IS_SI_STATIC_DEMO = env.VITE_IS_SI_STATIC_DEMO === 'true'
export const IS_PRGM_ENV = env.VITE_APP_NAME === 'Prgm'
export const IS_NPT_ENV = env.VITE_NPT === 'true'
/** Фильтры и сортировка в просмотре источника. Выключается явным `false` — по умолчанию включено. */
export const IS_SOURCE_VIEW_FILTERS_ENABLED = env.VITE_IS_SOURCE_VIEW_FILTERS_ENABLED !== 'false'
/**
 * Карточки источников и единая загрузка (методы `/api/v1/`).
 *
 * Выключается **явным** `false`. CI demand подставляет свой `ENV_FILE` без этого
 * ключа — opt-in через `=== 'true'` оставлял на стенде старый экран после мержа.
 */
export const IS_SOURCE_CARDS_ENABLED = env.VITE_IS_SOURCE_CARDS_ENABLED !== 'false'
/**
 * Список сценариев на методах `/api/v1/`: фильтры, серверная пагинация, карточка.
 *
 * Выключается **явным** `false` — по умолчанию включено. Старый список остаётся
 * путём отката до конца обкатки.
 */
export const IS_SCENARIOS_LIST_V2_ENABLED = env.VITE_IS_SCENARIOS_LIST_V2_ENABLED !== 'false'
/**
 * Колоночные фильтры в таблице ракурса: воронка с мультивыбором в шапке колонки
 * вместо отдельной строки чипов. Выключается **явным** `false` — по умолчанию
 * включено; старый `PerspectiveFilterChips` остаётся путём отката.
 */
export const IS_PERSP_COLUMN_FILTERS_ENABLED = env.VITE_IS_PERSP_COLUMN_FILTERS_ENABLED !== 'false'
/**
 * Качество прогноза v2 — оценка по запросу (SDD 25): мастер выбора прогноза/факта/окна,
 * расчёт одной задачей, дашборды v8 по выбранной оценке. Выключается **явным** `false`;
 * старые `QualityTab`/`CorrectionsTab` с авто-снапшотом остаются путём отката.
 */
export const IS_QUALITY_ON_DEMAND_V2 = env.VITE_IS_QUALITY_ON_DEMAND_V2 !== 'false'
/**
 * Чанковая загрузка файла в карточку источника (init / chunks / complete).
 *
 * Выключается **явным** `false`. CI demand подставляет свой `ENV_FILE` без этого
 * ключа — opt-in через `=== 'true'` оставлял на стенде старый POST одним телом.
 */
export const IS_SOURCE_CHUNKED_UPLOAD = env.VITE_SOURCE_CHUNKED_UPLOAD !== 'false'
/**
 * Сжатие CSV в gzip перед чанковой отправкой (~x5 к скорости доставки).
 *
 * Выключается **явным** `false`, как остальные флаги. ВАЖНО: бэкенд должен уже
 * принимать `.csv.gz` (ALLOWED_EXTENSIONS) — фронт с этим флагом нельзя
 * выкатывать раньше бэкенда, иначе загрузка CSV сломается целиком. Откат при
 * проблемах: VITE_SOURCE_UPLOAD_GZIP=false.
 */
export const IS_SOURCE_UPLOAD_GZIP = env.VITE_SOURCE_UPLOAD_GZIP !== 'false'

const global: any = typeof window !== 'undefined' ? window : {}
global.setSessionOver = (seconds: number) => {
  localStorage.setItem('SESSION_OVER_MS', String(seconds * 1000))
  window.location.reload()
}
global.removeSessionOver = () => {
  localStorage.removeItem('SESSION_OVER_MS')
  window.location.reload()
}

export const {
  VITE_API_URL: API_URL,
  VITE_WS_URL: WS_URL,
  TEST: isTest,
  VITE_APP_NAME: APP_NAME,
  VITE_LOGO: LOGO,
} = env
